'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * react-svg-icon Accessible SVG icon component.
 */
var Icon = function Icon(_ref) {
    var name = _ref.name,
        title = _ref.title,
        className = _ref.className;
    return _react2.default.createElement(
        'svg',
        {
            className: 'i ' + (className || ''),
            'aria-hidden': title ? null : true
        },
        title ? _react2.default.createElement(
            'title',
            null,
            title
        ) : null,
        _react2.default.createElement('use', {
            xlinkHref: '#' + name,
            'aria-hidden': title ? true : null
        })
    );
};

Icon.propTypes = {
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string,
    className: _propTypes2.default.string
};

Icon.defaultProps = {
    title: null,
    className: null
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/react-svg-icon/dist/index.js
// module id = 475
// module chunks = 0